import { supabase } from "../../config/supabase";

export const getAppVersions = async (companyId, limit = 6) => {
    let query = supabase
        .from("app_versions")
        .select("*")
        .eq("is_published", true)
        .order("created_at", { ascending: false })
        .limit(limit);

    if (companyId) {
        query = query.or(`company_id.eq.${companyId},company_id.is.null`);
    } else {
        query = query.is("company_id", null);
    }

    const { data, error } = await query;
    return { data: data || [], error };
};

export const updateLastSeenVersion = async (userId, version) => {
    const { data, error } = await supabase
        .from("users")
        .update({ last_seen_version: version })
        .eq("id", userId)
        .select()
        .maybeSingle();

    return { data, error };
};